import { useRequest } from 'ahooks';
import { useMemo } from 'react';
import { getRegionsStoreCount, RegionCountsMap } from 'services/api/admin';
import { toUpperCase } from 'utils/toLowerCase';

const useRegionList = () => {
  const {
    data = {
      SHOPEE: [],
      LAZADA: [],
      TOKOPEDIA: [],
      TIKTOK: [],
      TIKTOK_US: [],
      ALIEXPRESS: [],
      MERCADO: [],
      KWAI: [],
      FACEBOOK: [],
      JOLECT: [],
    },
    loading,
  } = useRequest(async () => {
    try {
      const {
        data: {
          data: {
            shopeeCountData: shopeeRegionCountsMap,
            lazadaCountData: lazadaRegionCountsMap,
            tokopediaCountData: tokopediaRegionCountsMap,
            tiktokCountData: tiktokRegionCountsMap,
            tiktokUsCountData: tiktokUsRegionCountsMap = {} as RegionCountsMap,
            aliExpressCountData: aliexpressRegionCountsMap = {} as RegionCountsMap,
            mercadoCountData: mercadoRegionCountsMap = {} as RegionCountsMap,
            kwaiCountData: kwaiRegionCountsMap = {} as RegionCountsMap,
            facebookCountData: facebookRegionCountsMap = {} as RegionCountsMap,
            jolectCountData: jolectRegionCountsMap = {} as RegionCountsMap,
          },
        },
      } = await getRegionsStoreCount();
      const SHOPEE = Object.keys(shopeeRegionCountsMap).map(
        (key) => toUpperCase(key.replace(/^(\w{2,})Cnt$/, '$1')) as General.UpperCaseRegion,
      );
      const LAZADA = Object.keys(lazadaRegionCountsMap).map(
        (key) => toUpperCase(key.replace(/^(\w{2,})Cnt$/, '$1')) as General.UpperCaseRegion,
      );
      const TOKOPEDIA = Object.keys(tokopediaRegionCountsMap).map(
        (key) => toUpperCase(key.replace(/^(\w{2,})Cnt$/, '$1')) as General.UpperCaseRegion,
      );
      const TIKTOK = Object.keys(tiktokRegionCountsMap).map(
        (key) => toUpperCase(key.replace(/^(\w{2,})Cnt$/, '$1')) as General.UpperCaseRegion,
      );
      const TIKTOK_US = Object.keys(tiktokUsRegionCountsMap).map(
        (key) => toUpperCase(key.replace(/^(\w{2,})Cnt$/, '$1')) as General.UpperCaseRegion,
      );
      const ALIEXPRESS = Object.keys(aliexpressRegionCountsMap).map(
        (key) => toUpperCase(key.replace(/^(\w{2,})Cnt$/, '$1')) as General.UpperCaseRegion,
      );
      const MERCADO = Object.keys(mercadoRegionCountsMap).map(
        (key) => toUpperCase(key.replace(/^(\w{2,})Cnt$/, '$1')) as General.UpperCaseRegion,
      );
      const KWAI = Object.keys(kwaiRegionCountsMap).map(
        (key) => toUpperCase(key.replace(/^(\w{2,})Cnt$/, '$1')) as General.UpperCaseRegion,
      );
      const FACEBOOK = Object.keys(facebookRegionCountsMap).map(
        (key) => toUpperCase(key.replace(/^(\w{2,})Cnt$/, '$1')) as General.UpperCaseRegion,
      );
      const JOLECT = Object.keys(jolectRegionCountsMap).map(
        (key) => toUpperCase(key.replace(/^(\w{2,})Cnt$/, '$1')) as General.UpperCaseRegion,
      );
      return {
        SHOPEE,
        LAZADA,
        TOKOPEDIA,
        TIKTOK,
        TIKTOK_US,
        ALIEXPRESS,
        MERCADO,
        KWAI,
        FACEBOOK,
        JOLECT,
      };
    } catch (error) {
      return {
        SHOPEE: [],
        LAZADA: [],
        TOKOPEDIA: [],
        TIKTOK: [],
        TIKTOK_US: [],
        ALIEXPRESS: [],
        MERCADO: [],
        KWAI: [],
        FACEBOOK: [],
        JOLECT: [],
      };
    }
  });

  const filterdData = useMemo(() => {
    return Object.keys(data).reduce((res, key) => {
      res[key] = res[key].filter((region) => region !== 'TW');

      return res;
    }, data);
  }, [data]);

  const platforms = useMemo(() => {
    if (!filterdData) {
      return [];
    }
    return Object.keys(filterdData)
      .filter((x) => filterdData[x].length > 0)
      .map((x) => toUpperCase(x));
  }, [filterdData]);
  return {
    regions: filterdData,
    platforms,
    loading,
  };
};

export default useRegionList;
